import { maxValue, minValue, required, requiredIf } from 'vuelidate/lib/validators';
import FieldType from '@/ecm/variables/FieldType';

export default {
  contentType: { required },
  fields: {
    $each: {
      value: {
        required: requiredIf(function (model) {
          return model.isRequired;
        }),
        minValue: function (value, model) {
          if (model.type === FieldType.Numeric && value !== null && value !== '') {
            const userDecSep = this.$store.getters['account/user'].MetricDecimalSep;
            value = value.replaceAll(userDecSep, '.');
            return minValue(model.validations.minVal)(parseFloat(value));
          }
          return true;
        },
        maxValue: function (value, model) {
          if (model.type === FieldType.Numeric && value !== null && value !== '') {
            const userDecSep = this.$store.getters['account/user'].MetricDecimalSep;
            value = value.replaceAll(userDecSep, '.');
            return maxValue(model.validations.maxVal)(parseFloat(value));
          }
          return true;
        },
      },
    },
  },
};
